const { Type } = require('@sinclair/typebox');
const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP = 'Criteria element for use on FORMS to document a constrain on an number field';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock reference to the block as a whole
 * @param {Object} mdcBlock Meta Data Configuration block. the group definition from blockGroupConfiguration.js
 * @param {import('blockly').Input} line1OfInputs First line of inputs, already including the Block name and the title field
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged horizontally.
    //this gets the security modifier in line with the fields
    //because we only have one line of fields, that looks better
    blocklyBlock.setInputsInline(true);

    line1OfInputs
        .appendField('  Property Name:')
        .appendField(new Blockly.FieldTextInput('title'), 'propertyName')
        .appendField('  Min:')
        .appendField(new Blockly.FieldNumber('0', Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, 1), 'min')
        .appendField('  Max:')
        .appendField(new Blockly.FieldNumber('9999', Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, 1), 'max')
        .appendField('  Tooltip:')
        .appendField(new Blockly.FieldTextInput(''), 'tooltip');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);

    addCodeProperties([
        'propertyName',
        { key: 'max', handler: parseInt },
        { key: 'min', handler: parseInt },
        'tooltip'
    ]);

    return code;
}

/** Builds the criteria schema fragment for the IntegerCriteria workflow element. */
function asDataDictionary(hNode, context) {
    const { propertyName, required = false } = hNode;

    // we could be on an update form, or on a new form, or nested somewhere
    // We just don't know what accessContext this would be enabling, nor how it is applied on a NS/REL
    // Security Modifiers (which would disabled certain accessContext) are processed generically
    // All we know is that Whatever propertyName is on this Criteria block
    // and how it is formatted.

    // Create TypeBox integer schemas for each operator with min/max constraints
    const eqSchema = Type.Optional(
        Type.Integer({
            title: 'Test for equality',
            'x-dataType': 'integer',
            'x-propertyName': '_eq',
            'x-optional': !required,
            minimum: hNode.min,
            maximum: hNode.max
        })
    );

    const gtSchema = Type.Optional(
        Type.Integer({
            title: 'Test for greater than',
            'x-dataType': 'integer',
            'x-propertyName': '_gt',
            'x-optional': !required,
            minimum: hNode.min,
            maximum: hNode.max
        })
    );

    const ltSchema = Type.Optional(
        Type.Integer({
            title: 'Test for less than',
            'x-dataType': 'integer',
            'x-propertyName': '_lt',
            'x-optional': !required,
            minimum: hNode.min,
            maximum: hNode.max
        })
    );

    // Create main criteria object containing all operators
    const criteriaSchema = Type.Object(
        {
            _eq: eqSchema,
            _gt: gtSchema,
            _lt: ltSchema
        },
        {
            'x-id': hNode.id,
            title: hNode.title,
            'x-tooltip': hNode.tooltip,
            'x-propertyName': propertyName,
            'x-dataType': 'object',
            'x-optional': !required,
            additionalProperties: false
        }
    );

    const partialTypeDefinition = {
        [propertyName]: required ? criteriaSchema : Type.Optional(criteriaSchema)
    };

    return [{}, partialTypeDefinition];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
